/**
 * inElement is an optional parameter :
 *  if defined, the scroll will occur in inElement.
 *  If not defined, the scroll will occur on window object.
 * @param { number } to
 * @param { number } time
 * @param { Element= } inElement
 * @param { function } callback
 */
export default function(to, time, inElement = window, callback) {
    const initialTop = window.pageYOffset;
    const distance = Math.abs(initialTop - to);

    let direction = 1;

    if (to < initialTop) {
        direction = -1;
    }

    let start = false;

    function scrollTo(timestamp) {
        if (!start) {
            start = timestamp;
        }

        const progress = timestamp - start;
        let newTop = initialTop + direction * distance * (progress / time);

        /**
         * Workaround to fix Scroll issue
         */
        if ((direction > 0 && newTop > to) || (direction < 0 && newTop < to))
            newTop = to;

        inElement.scrollTo(0, newTop);

        if (progress < time) {
            window.requestAnimationFrame(scrollTo);
        } else if (callback) {
            callback();
        }
    }

    window.requestAnimationFrame(scrollTo);
}
